<template>
  <div>
    <ProjectFilter />
    <transition name="project-list">
      <ProjectList
        v-if="$route.query.view === 'list' && projects"
        :projects="projects"
      />
    </transition>
    <transition name="project-list">
      <ProjectWall
        v-if="$route.query.view !== 'list' && projects"
        :projects="projects"
      />
    </transition>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import { Project } from 'beisheim/models'
import { sortBy } from 'lodash'
import ProjectFilter from 'beisheim/components/elements/project-filter'
import ProjectWall from 'beisheim/components/elements/project-wall'
import ProjectList from 'beisheim/components/elements/project-list'

export default {
  components: {
    ProjectFilter,
    ProjectWall,
    ProjectList
  },
  mixins: [ editable ],
  computed: {
    projects () {
      const query = Project
        .where(r => r.language === this.resource.language && r.country === this.resource.country && !r.name.startsWith('_'))
      if (this.$route.query.focus) {
        query.where(r =>
          r.columns.focus && (r.columns.focus.toLowerCase() === this.$route.query.focus)
        )
      }
      const projects = query.get()
      return sortBy(projects, p => p.columns.teaser && p.columns.teaser.title && p.columns.teaser.title.toLowerCase())
    }
  }
}
</script>

<style lang="scss">
.project-list-enter-active {
  transition: all 500ms cubic-bezier(.19,0,.19,1);
}

.project-list-enter {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
